module.exports = __webpack_public_path__ + "img/server.78ca4f7d.png";